import { render, staticRenderFns } from "./CoefficientOfTerritorialZonesEditModal.vue?vue&type=template&id=194e56f4&scoped=true&"
import script from "./CoefficientOfTerritorialZonesEditModal.vue?vue&type=script&lang=js&"
export * from "./CoefficientOfTerritorialZonesEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e56f4",
  null
  
)

export default component.exports